import { on } from 'delegated-events'
import 'lightgallery.js/dist/js/lightgallery.js'
import 'lg-thumbnail.js/dist/lg-thumbnail.js'
import 'lightgallery.js/dist/css/lightgallery.css'

const lightGallery = window.lightGallery

const galleryEl = document.querySelector('[data-photo-gallery]')

const fn = {
  init: () => {
    on('click', '.gallery-show-more', (e) => {
      galleryEl.querySelectorAll('.gallery-item.hidden').forEach((x) => x.classList.remove('hidden'))
      galleryEl.querySelectorAll('.gallery-item.mobile-hidden').forEach((x) => x.classList.remove('mobile-hidden'))
      e.currentTarget.classList.add('hidden')

      document.querySelectorAll('.gallery-show-more').forEach((x) => x.parentNode.removeChild(x))
    })

    on('click', '[data-gallery-trigger]', (e) => {
      e.preventDefault()

      const gallery = e.target.closest('[data-photo-gallery]')
      const startIndex = e.currentTarget.dataset.galleryIndex || 0
      const galleryData = JSON.parse(gallery.dataset.photoGallery)

      lightGallery(gallery, {
        index: parseInt(startIndex),
        dynamic: true,
        dynamicEl: galleryData,
        thumbnail: true,
        download: false,
      })

      gallery.addEventListener(
        'onCloseAfter',
        () => {
          const uid = gallery.getAttribute('lg-uid')

          if (Object.prototype.hasOwnProperty.call(window.lgData, uid)) {
            window.lgData[uid].destroy(true)
          }
        },
        { once: true }
      )
    })
  },
}

export default {
  can: () => galleryEl,
  run: fn.init,
}
